/* @flow */

export const templateContainer = {
  display: 'grid',
  fallbacks: {
    display: '-ms-grid',
  },

  minHeight: '100%',
};

export const templateItem = {
  // Required by IE11
  display: 'block',

  // https://css-tricks.com/preventing-a-grid-blowout/
  minWidth: 0,
};

export const sideBarTabletWidth = 178;
export const sideBarLapWidth = 328;

export const mainTabletWidth = 530;
export const mainLapWidth = 580;

export const navBarMobileHeight = 72;
